import { render, staticRenderFns } from "./RegimenAduanero.vue?vue&type=template&id=4ea26834&"
import script from "./RegimenAduanero.vue?vue&type=script&lang=js&"
export * from "./RegimenAduanero.vue?vue&type=script&lang=js&"
import style0 from "./RegimenAduanero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports